import React from 'react'

const Status = () => {
    return (
        <i class="fas fa-circle mr-2"></i>
    )
}

export default Status